import React from 'react';
import { Grid } from '@material-ui/core';

import Title from 'components/typography/Title';
import RecipesList from 'components/recipes/list/RecipesList';
import RecipeListLoading from 'components/recipes/list/RecipesListLoading';

import useLatestRecipes from './useLatestRecipes';

import InfiniteScroll from './InfiniteScroll';
import FailedWarning from './FailedWarning';

const LatestRecipes = () => {
  const {
    recipes,
    loadMoreRecipes,
    hasFailed,
    hasFinished,
  } = useLatestRecipes();

  const isFirstLoad = recipes.length === 0;

  return (
    <Grid container direction="column">
      <Grid item>
        <Title>Latest Recipes</Title>
      </Grid>

      <Grid item xs={12} md={8} container style={{ marginTop: 32 }}>
        <InfiniteScroll
          loadData={loadMoreRecipes}
          loadMoreData={!hasFailed && !hasFinished}
          lastItem={
            <div style={{ paddingTop: isFirstLoad ? 0 : 24, width: '100%' }}>
              {hasFailed ? (
                <FailedWarning
                  onTryAgainButtonClick={loadMoreRecipes}
                ></FailedWarning>
              ) : (
                <RecipeListLoading
                  count={isFirstLoad ? 4 : hasFinished ? 0 : 1}
                ></RecipeListLoading>
              )}
            </div>
          }
        >
          <RecipesList recipes={recipes}></RecipesList>
        </InfiniteScroll>
      </Grid>
    </Grid>
  );
};

export default LatestRecipes;
